import { Injectable } from '@angular/core';
import { ICuc } from './user-requests.service';

@Injectable({
  providedIn: 'root',
})
export class UserStoreService {
  documentType: string;
  document: string;
  cuc: string;
  userProtectedData: any;
  lasActive: Date;
  userCUC: ICuc[] = [];
  activeCUC: ICuc;
  authToken: string;
  authToken_: string;
  parametroJuridico: string;
  COGNITO_USER: any;
  COGNITO_USER_DATA: { 
    gender: string;
    given_name: string;
    name: string;
    email: string;
    phone_number: string;
  };
  COGNITO_TOKEN: string;
  COGNITO_CODE: string;
  COGNITO_TOTP_TOKEN: string;
  adviserData: { correo: string; nombre: string; telefono: string };
  configuracionCodigo: [];
  nombres : string;
  apellidos : string;
  //
  constructor() {}

  get userName() {
    if(this.COGNITO_USER_DATA){
      if(this.COGNITO_USER_DATA.given_name){
        return `${this.COGNITO_USER_DATA.name} ${this.COGNITO_USER_DATA.given_name}`;
      }else{
        return this.COGNITO_USER_DATA.name;
      }
    }
  }

  get gender() {
    if(this.COGNITO_USER_DATA){
    return this.COGNITO_USER_DATA.gender;
    }
  }
}
